export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
        "abbr": ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
      },
      "days": {
        "full": ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
        "abbr": ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
      },
      "patterns": {
        "longDate": "dddd, MMMM D, YYYY",
        "dateSlash": "MM/DD/YYYY",
        "dateShort": "dddd, MMMM D",
        "dateMedium": "dddd, MMMM D - h[:]mm a",
        "dateLarge": "D MMM YYYY h[:]mm[:]ss a",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["(Sn)", "Sn"]
      },
      "group": {
        "separator": ",",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ".",
        "length": 2
      },
      "ordinal": function(number) { var b = number % 10; return number + ((number % 100 / 10) === 1 ? 'th' : (b === 1) ? 'st' : (b === 2) ? 'nd' : (b === 3) ? 'rd' : 'th'); }
    }
  },
  "translations": {
    "messages": {
  " CASH ": [
    null,
    " CASH "
  ],
  "!action:Deposit": [
    null,
    "Deposit"
  ],
  "!desc:BetRefundOffer": [
    null,
    "Double your first deposit, up to €200<br /><br />To celebrate your arrival on Winamax, you will benefit from two welcome offers when you make your first deposit: a bonus of up to €250 and double your first deposit offered in Freebets, up to €200*! You will therefore be able to start betting on sports immediately.<br /><br />The 2 offers are cumulative and automatically triggered on your first deposit, if you choose to do so."
  ],
  "!desc:BetRefundOffer100": [
    null,
    "Your first deposit in Freebets, up to €100<br /><br />To celebrate your arrival on Winamax, you will benefit from two welcome offers when you make your first deposit: a bonus of up to €250 and your first deposit offered in Freebets, up to €100*! You will therefore be able to start betting on sports immediately.<br /><br />The 2 offers are cumulative and automatically triggered on your first deposit, if you choose to do so."
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "* Before making any withdrawal, the amount of the initial deposit must be wagered in sports betting on Winamax.fr with your real money balance (within the limit of €100 if it is higher). This can be done by placing one or more bets (excluding Freebets). Cancelled bets and Cashout bets are not taken into account."
  ],
  "!desc:CondFirstDeposit": [
    null,
    "* The first deposit offer is valid only once per user, terminal (computer, tablet or mobile), household, credit card or bank account. It is reserved for players who have never made a deposit on a Winamax account (including on an account that has since been closed)."
  ],
  "!desc:DefaultLandingContent": [
    null,
    "<div class=\"hide-for-small\">\n<p>To celebrate your arrival on Winamax, take advantage of two welcome offers with your first deposit : <b>the amount of your first deposit in Freebets up to €100 </b> ! As well as a <b>bonus of up to €250</b>*</p><br />\n<p>The 2 offers are cumulative and automatically triggered when you make your first deposit, if you so choose.  </p><br />\n<p>So what are you waiting for to join the room with the <b>best welcome bonus?</b></p><br />\n<h2> How does it work?   </h2>\n<br />\n<p>When you make your very first time deposit at Winamax, and before any game action, you are offered the amount of your deposit in Freebets up to €100.\n<br />\nFor example, if you deposit €100 at Winamax, you will immediately receive €100 in Freebets in your account and can start betting on the different sports. Net winnings from Freebets are paid in cash into your account.\n<br />\nWe will also give you a bonus equal to your deposit, up to a maximum of €250. We will credit your Winamax account with 20% of the value of the bonus as soon as you have earned enough Miles (Miles are loyalty points earned by playing poker and making sports bets). 30 Miles are all you need to earn a €1 bonus. So, if you deposited €100 on your first deposit, we will credit you €20 when you reach 600 Miles, then another €20 when you reach 1200 Miles, etc. In total, you will be credited with an additional €100 when you have accumulated 3000 Miles.\n</p>\n<br />\n<p><small><i>*Please note that the first deposit bonus can only be applied once per user, device (computer, tablet or mobile), household or bank account and is reserved for players who have never made a deposit on a Winamax account (including on an account that has since been closed).<a href=\"https://www.winamax.fr/en/first-deposit-bonus\" target=\"_blank\"> See conditions</i></a>.\n</div>\n"
  ],
  "!desc:DefaultLandingContentES": [
    null,
    ""
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    "<h2>How does it work?</h2>\n<br />\n<p>When you make your very first time deposit at Winamax, and before any game action, you are offered the amount of your deposit in Freebets up to €100.\n<br />\nFor example, if you deposit €100 at Winamax, you will immediately receive €100 in Freebets in your account and can start betting on the different sports. Net winnings from Freebets are paid in cash into your account.\n<br />\nWe will also give you a bonus equal to your deposit, up to a maximum of €250. We will credit your Winamax account with 20% of the value of the bonus as soon as you have earned enough Miles (Miles are loyalty points earned by playing poker and making sports bets). 30 Miles are all you need to earn a €1 bonus. So, if you deposited €100 on your first deposit, we will credit you €20 when you reach 600 Miles, then another €20 when you reach 1200 Miles, etc. In total, you will be credited with an additional €100 when you have accumulated 3000 Miles.\n</p>\n<br />\n<small><i>*Please note that the first deposit bonus can only be applied once per user, device (computer, tablet or mobile), household or bank account and is reserved for players who have never made a deposit on a Winamax account (including on an account that has since been closed).<a href=\"https://www.winamax.fr/en/first-deposit-bonus\" target=\"_blank\"> See conditions</a></i></small>.\n"
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    ""
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    ""
  ],
  "!placeholder:dd": [
    null,
    "dd"
  ],
  "!placeholder:mm": [
    null,
    "mm"
  ],
  "!placeholder:yy": [
    null,
    "yy"
  ],
  "!placeholder:yyyy": [
    null,
    "yyyy"
  ],
  ", if you lost": [
    null,
    ", if you lost"
  ],
  "1st bet refunded up to €100": [
    null,
    "Up to €200 free, instantly!*"
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    ""
  ],
  "A receipt for your rent": [
    null,
    "A receipt for your rent"
  ],
  "Above": [
    null,
    "Above"
  ],
  "Acceptable ID": [
    null,
    "Acceptable ID"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Acceptable formats: %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Acceptable proof of address documents"
  ],
  "Account already exist": [
    null,
    "There already exists an account with this email address/phone number."
  ],
  "Account creation complete": [
    null,
    "Account creation complete"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Account creation: complete.<br />That's what<br />we're talking about!"
  ],
  "Account number": [
    null,
    "Account number"
  ],
  "Activation code": [
    null,
    "Activation code"
  ],
  "Add a bank card": [
    null,
    "Add a bank card"
  ],
  "Add my bank card": [
    null,
    "Add my bank card"
  ],
  "Add my bank card details": [
    null,
    "Add my bank card details"
  ],
  "Address details": [
    null,
    "Address details"
  ],
  "All countries": [
    null,
    "All countries"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "An error has occured when checking your CAPTCHA score. Please try again later."
  ],
  "Analysis": [
    null,
    "Analysis"
  ],
  "Automatic withdrawal": [
    null,
    "Automatic withdrawal"
  ],
  "Automatic withdrawal threshold": [
    null,
    "Automatic withdrawal threshold"
  ],
  "BOOM! You can start playing!": [
    null,
    "BOOM! You can start playing!"
  ],
  "Back": [
    null,
    "Back"
  ],
  "Back to homepage": [
    null,
    "Back to homepage"
  ],
  "Bank": [
    null,
    "Bank"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "Bank accounts from this country are not accepted on Winamax"
  ],
  "Bank card number": [
    null,
    "Bank card number"
  ],
  "Bank code": [
    null,
    "Bank code"
  ],
  "Bank office": [
    null,
    "Bank office"
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100."
  ],
  "Beginner": [
    null,
    "Beginner"
  ],
  "Beginner profile token": [
    null,
    "Beginner profile token"
  ],
  "Beneficiary": [
    null,
    "Beneficiary"
  ],
  "Bet on sports": [
    null,
    "Bet on sports"
  ],
  "Betting limit - Poker": [
    null,
    "Betting limit - Poker"
  ],
  "Betting limit - Sport betting": [
    null,
    "Betting limit - Sport betting"
  ],
  "Birth date": [
    null,
    "Birth date"
  ],
  "Birth name": [
    null,
    ""
  ],
  "Bonus up to €250": [
    null,
    "Bonus up to €250"
  ],
  "Boom!": [
    null,
    "Boom!"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    ""
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)"
  ],
  "Card number": [
    null,
    "Card number"
  ],
  "Change address": [
    null,
    "Change address"
  ],
  "Change my deposit limit": [
    null,
    "Change my deposit limit"
  ],
  "Change my limit": [
    null,
    "Change my limit"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "Change your account details in order to receive your activation code by post."
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Check that your bank card information is accurate and complete the cryptogram."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Choose a deposit method in order to make your first deposit."
  ],
  "Choose a deposit method.": [
    null,
    "Choose a deposit method."
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Choose the amount of your first deposit in order to start playing."
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Choose the amount you wish to deposit in order to continue playing."
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    "Choose the maximum amount you wish to deposit per month."
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Choose the maximum amount you wish to deposit per week."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    "Choose the profile that best suits your playing style! You can also change the values manually."
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Choose which bank card you want to use to make a deposit."
  ],
  "Choose your country code": [
    null,
    "Choose your country code"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Choose your limit well in order to take advantage of your bonus."
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society."
  ],
  "City": [
    null,
    "City"
  ],
  "Click & drag your file here": [
    null,
    "Click & drag your file here"
  ],
  "Close": [
    null,
    "Close"
  ],
  "Come and take a seat": [
    null,
    "Come and take a seat"
  ],
  "Complete registration now": [
    null,
    "Complete registration now"
  ],
  "Confirm limit": [
    null,
    "Confirm limit"
  ],
  "Confirm my details": [
    null,
    "Confirm my details"
  ],
  "Confirm my limit": [
    null,
    "Confirm my limit"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Confirm your details in order to receive a new activation code by post."
  ],
  "Continue": [
    null,
    "Continue"
  ],
  "Continue my deposit": [
    null,
    "Continue my deposit"
  ],
  "Continue with PayPal": [
    null,
    "Continue with PayPal"
  ],
  "Country": [
    null,
    "Country"
  ],
  "Country of birth": [
    null,
    "Country of birth"
  ],
  "Country of residence": [
    null,
    "Country of residence"
  ],
  "Create my account": [
    null,
    "Create my account"
  ],
  "Creation": [
    null,
    "Creation"
  ],
  "Cryptogram": [
    null,
    "Cryptogram"
  ],
  "Deposit": [
    null,
    "Deposit"
  ],
  "Deposit limit": [
    null,
    "Deposit limit"
  ],
  "Deposit on my account": [
    null,
    "Deposit on my account"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Deposit on your Winamax account by bank transfer"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Deposit on your account with Neteller."
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Deposit with Moneybookers/Skrill."
  ],
  "Document": [
    null,
    "Document"
  ],
  "Document number": [
    null,
    "Document number"
  ],
  "Don't forget to send us your ID to validate your account and withdraw your winnings.": [
    null,
    ""
  ],
  "Driver's licence": [
    null,
    "Driver's licence"
  ],
  "Driver's license": [
    null,
    "Driver's license"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Driver's license: whole document with photo or front and back sides"
  ],
  "Edit email/phone number": [
    null,
    "Edit email/phone number"
  ],
  "Email": [
    null,
    "Email"
  ],
  "Enter a different amount": [
    null,
    "Enter a different amount"
  ],
  "Enter amount": [
    null,
    "Enter amount"
  ],
  "Enter my information": [
    null,
    "Enter my information"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Enter the activation code sent to you by post."
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Enter the code sent by text message to %1$s to verify your phone number."
  ],
  "Experienced": [
    null,
    "Experienced"
  ],
  "Experienced profile token": [
    null,
    "Experienced profile token"
  ],
  "Expiry date": [
    null,
    "Expiry date"
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    ""
  ],
  "Female": [
    null,
    "Female"
  ],
  "Fill in my details": [
    null,
    "Fill in my details"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Complete the following form. Or directly fill out your information with Paypal"
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Fill out the form with your bank card information."
  ],
  "First deposit": [
    null,
    "First deposit"
  ],
  "First name": [
    null,
    "First name"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    "For a Spanish nationality, you must supply us with a DNI and not a NIE"
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    "For a foreign nationality, you must supply us with a NIE and not a DNI"
  ],
  "Free registration": [
    null,
    "Free registration"
  ],
  "Full name on card": [
    null,
    "Full name on card"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "GG!<br />Your account has<br />been validated!"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Gambling is prohibited for minors"
  ],
  "General Terms and Conditions": [
    null,
    "General Terms and Conditions"
  ],
  "Health card: front and back": [
    null,
    "Health card: front and back"
  ],
  "Hold on": [
    null,
    "Hold on"
  ],
  "I accept the ": [
    null,
    "I accept the "
  ],
  "I agree to gain access to all": [
    null,
    ""
  ],
  "I have not received my code": [
    null,
    "I have not received my code"
  ],
  "I need a new code": [
    null,
    "I need a new code"
  ],
  "I want to receive offers and news": [
    null,
    ""
  ],
  "I will deposit later": [
    null,
    "I will deposit later"
  ],
  "I will send it at a later time": [
    null,
    "I will send it at a later time"
  ],
  "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions": [
    null,
    "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions"
  ],
  "IBAN": [
    null,
    "IBAN"
  ],
  "ID card: front and back": [
    null,
    "ID card: front and back"
  ],
  "ID card: front side": [
    null,
    "ID card: front side"
  ],
  "Identity card": [
    null,
    "Identity card"
  ],
  "Identity not verified": [
    null,
    "Identity not verified"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    ""
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "Important! Make sure you add the following reference for your transfer:"
  ],
  "In 30 seconds": [
    null,
    "In 30 seconds"
  ],
  "In order to be able to play for real money, you must submit an ID and proof of address.": [
    null,
    ""
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "In order to make your deposit, add your bank card or any other deposit method."
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "In order to make your first deposit, add your bank card or any other deposit method."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    ""
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    ""
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "In order to validate your account, you must upload a photo of your ID."
  ],
  "Incorrect format in this field": [
    null,
    "Incorrect format in this field"
  ],
  "Incorrect tax code": [
    null,
    "Incorrect tax code"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Incorrect value in this field, the department does not match the city."
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers."
  ],
  "Invalid phone number format.": [
    null,
    "Invalid phone number format."
  ],
  "It seems there is a connection problem": [
    null,
    "It seems there is a connection problem"
  ],
  "It's time to get serious": [
    null,
    ""
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "Join Winamax and take advantage of our welcome offer!"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "Keep an <br />eye on your<br />dough!"
  ],
  "Last name": [
    null,
    "Last name"
  ],
  "Last<br />sprint!": [
    null,
    "Last<br />sprint!"
  ],
  "Leave": [
    null,
    "Leave"
  ],
  "Loading...": [
    null,
    "Loading..."
  ],
  "Log in": [
    null,
    "Log in"
  ],
  "Make a deposit": [
    null,
    "Make a deposit"
  ],
  "Male": [
    null,
    "Male"
  ],
  "Maximum amount per month": [
    null,
    ""
  ],
  "Maximum amount per week": [
    null,
    "Maximum amount per week"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Missing application initialization parameters. Please try again."
  ],
  "Moneybookers email": [
    null,
    "Moneybookers email"
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    ""
  ],
  "NIE number": [
    null,
    "NIE number"
  ],
  "Nationality": [
    null,
    "Nationality"
  ],
  "Neteller Secure ID": [
    null,
    "Neteller Secure ID"
  ],
  "Neteller account": [
    null,
    "Neteller account"
  ],
  "No godfather found for this code": [
    null,
    "No godfather found for this code"
  ],
  "No minors": [
    null,
    "No minors"
  ],
  "Not connected": [
    null,
    "Not connected"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Oops,": [
    null,
    "Oops,"
  ],
  "Open your account": [
    null,
    "Open your account"
  ],
  "Optional": [
    null,
    "Optional"
  ],
  "Other deposit methods": [
    null,
    "Other deposit methods"
  ],
  "Other suggestions": [
    null,
    "Other suggestions"
  ],
  "Our bank details for your transfer:": [
    null,
    "Our bank details for your transfer:"
  ],
  "Passport": [
    null,
    "Passport"
  ],
  "Passport: whole page with photo": [
    null,
    "Passport: whole page with photo"
  ],
  "Password": [
    null,
    "Password"
  ],
  "Per month": [
    null,
    "Per month"
  ],
  "Per week": [
    null,
    "Per week"
  ],
  "Personal information": [
    null,
    "Personal information"
  ],
  "Phone number": [
    null,
    "Phone number"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Phone, internet, water, gas or electricity bills"
  ],
  "Place of birth": [
    null,
    "Place of birth"
  ],
  "Play on the app !": [
    null,
    "Play on the app!"
  ],
  "Play poker": [
    null,
    "Play poker"
  ],
  "Play time - Poker": [
    null,
    "Play time - Poker"
  ],
  "Poker Terms and Conditions": [
    null,
    "Poker Terms and Conditions"
  ],
  "Postal address": [
    null,
    "Postal address"
  ],
  "Postal code": [
    null,
    "Postal code"
  ],
  "Privacy Policy": [
    null,
    "Privacy Policy"
  ],
  "Processing": [
    null,
    "Processing"
  ],
  "Protect your behind!": [
    null,
    "Protect your behind!"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "Protect<br />your<br />behind!"
  ],
  "Province": [
    null,
    "Province"
  ],
  "RIB key": [
    null,
    "RIB key"
  ],
  "Reference": [
    null,
    "Reference"
  ],
  "Referral": [
    null,
    ""
  ],
  "Referral code": [
    null,
    ""
  ],
  "Region of birth": [
    null,
    "Region of birth"
  ],
  "Register": [
    null,
    "Register"
  ],
  "Register with my email": [
    null,
    "Register with my email"
  ],
  "Register with my phone number": [
    null,
    "Register with my phone number"
  ],
  "Registration": [
    null,
    "Registration"
  ],
  "Registration complete!": [
    null,
    "Registration complete!"
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "Registration not allowed from this country of residence."
  ],
  "Regular": [
    null,
    "Regular"
  ],
  "Regular profile token": [
    null,
    "Regular profile token"
  ],
  "Residence permit: front and back": [
    null,
    "Residence permit: front and back"
  ],
  "Responsible gaming": [
    null,
    "Responsible gaming"
  ],
  "SWIFT code": [
    null,
    "SWIFT code"
  ],
  "Save this card for future deposits": [
    null,
    "Save this card for future deposits"
  ],
  "Scan my ID": [
    null,
    "Scan my ID"
  ],
  "Scan my bank card": [
    null,
    "Scan my bank card"
  ],
  "Scan my verification document": [
    null,
    "Scan my verification document"
  ],
  "Search": [
    null,
    "Search"
  ],
  "See Ts&Cs for the offer": [
    null,
    "See Ts&Cs for the offer"
  ],
  "See accepted verification documents": [
    null,
    "See accepted verification documents"
  ],
  "See what IDs we accept": [
    null,
    "See what IDs we accept"
  ],
  "Select your file": [
    null,
    "Select your file"
  ],
  "Send ID": [
    null,
    ""
  ],
  "Send back of document": [
    null,
    ""
  ],
  "Send documents": [
    null,
    ""
  ],
  "Send my ID": [
    null,
    "Send my ID"
  ],
  "Send my new code": [
    null,
    "Send my new code"
  ],
  "Send my verification documents": [
    null,
    "Send my verification documents"
  ],
  "Send proof of identity": [
    null,
    ""
  ],
  "Sex": [
    null,
    "Gender"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "Show<br />us who<br />you are!"
  ],
  "Skip this step": [
    null,
    "Skip this step"
  ],
  "Skrill email": [
    null,
    "Skrill email"
  ],
  "Social security card": [
    null,
    "Social security card"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Sports betting Terms and Conditions"
  ],
  "Starting at €%1$s": [
    null,
    "Starting at €%1$s"
  ],
  "Successfully uploaded!": [
    null,
    "Successfully uploaded!"
  ],
  "Super-player created!": [
    null,
    "Super-player created!"
  ],
  "Surname": [
    null,
    "Surname"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Take 2 minutes to create your account."
  ],
  "Tax Code": [
    null,
    "Tax Code"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Tax bill or home insurance letter"
  ],
  "Terms and Conditions": [
    null,
    "Terms and Conditions"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "The activation code cannot be over %1$s characters."
  ],
  "The activation code is not valid.": [
    null,
    "The activation code is not valid."
  ],
  "The best odds are your odds": [
    null,
    "The best odds are your odds"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "The current process seems to be slow. Try again."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "The identity verification service is unavailable. Please try again later."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    "The maximum amount of time (in hours) you can spend at the poker tables each week."
  ],
  "The maximum amount of your balance (bankroll) above which any additional winnings will be transferred directly to your bank account. Your account must be validated beforehand and we will need your bank details.": [
    null,
    "The maximum amount of your balance (bankroll) above which any additional winnings will be transferred directly to your bank account. Your account must be validated beforehand and we will need your bank details."
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    "The maximum amount you can deposit into your account each week for sports betting and poker."
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    "The maximum cumulative amount you can bet on poker each week."
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    "The maximum cumulative amount you can bet on sports betting each week."
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!"
  ],
  "There already exists an account with this email address.": [
    null,
    "There already exists an account with this email address."
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "These deposit methods are not available for this amount."
  ],
  "This code is required to create your account.": [
    null,
    "This code is required to create your account."
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "This field is mandatory to validate your deposit."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "This file format is invalid. Please try in one of the following formats: %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "This fiscal code is already linked to an active account"
  ],
  "This limit can be changed at any time in your account.": [
    null,
    "This limit can be changed at any time in your account."
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "This limit is mandatory for your account validation."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    ""
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    "This threshold can be changed at any time from your account."
  ],
  "This username is unavailable.": [
    null,
    "This username is unavailable."
  ],
  "This way for<br />money": [
    null,
    "This way for<br />money"
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Too many attempts with this identity. Please try again later."
  ],
  "Try again": [
    null,
    "Try again"
  ],
  "Ts&Cs": [
    null,
    "Ts&Cs"
  ],
  "Ts&Cs for the offer": [
    null,
    "Ts&Cs for the offer"
  ],
  "Type of cash-out": [
    null,
    "Type of cash-out"
  ],
  "Type of document": [
    null,
    "Type of document"
  ],
  "Unable to load profile information.": [
    null,
    "Unable to load profile information."
  ],
  "Unable to send verification message.": [
    null,
    "Unable to send verification message."
  ],
  "Unauthorised email.": [
    null,
    "Unauthorised email."
  ],
  "Up to": [
    null,
    "Up to"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    "Up to a limit of €100 or the same amount as your first deposit"
  ],
  "Up to €100 free, instantly!": [
    null,
    "Up to €100 free, instantly!"
  ],
  "Upload an identity document to continue registration.": [
    null,
    "Upload an identity document to continue registration."
  ],
  "Upload my ID": [
    null,
    "Upload my ID"
  ],
  "Upload my verification document": [
    null,
    "Upload my verification document"
  ],
  "Use France Connect": [
    null,
    "Use France Connect"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    "Use my existing deposit limit. If none is available, the limit set by you above will be applied."
  ],
  "Used or married name": [
    null,
    ""
  ],
  "Username": [
    null,
    "Username"
  ],
  "Validate": [
    null,
    "Validate"
  ],
  "Validate my deposit": [
    null,
    "Validate my deposit"
  ],
  "Validate my information": [
    null,
    "Validate my information"
  ],
  "Validate my limit": [
    null,
    "Validate my limit"
  ],
  "Validate my username": [
    null,
    "Validate my username"
  ],
  "Validation code": [
    null,
    "Validation code"
  ],
  "Verification": [
    null,
    "Verification"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Verify your phone number to receive a new text message with your validation code."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    ""
  ],
  "Want to<br />create a<br />username?": [
    null,
    "Want to<br />create a<br />username?"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "We are also offering a bonus of equal value to your first deposit."
  ],
  "We cannot accept land-line numbers.": [
    null,
    "We cannot accept land-line numbers."
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "Before any action even made on our site, we offer you the double of your initial deposit in Freebets, up to €200."
  ],
  "We're fetching your data...": [
    null,
    "We're fetching your data..."
  ],
  "Weekly betting limits": [
    null,
    "Weekly betting limits"
  ],
  "Welcome bonus": [
    null,
    "Welcome bonus"
  ],
  "Welcome to Winamax": [
    null,
    "Welcome to Winamax"
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "Welcome<br />to<br />Winamax!"
  ],
  "What is France Connect": [
    null,
    "What is France Connect"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    "With 168h per week, you can play for an unlimited period"
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    "Withdrawable cash credited to your account directly after the result of the first bet"
  ],
  "You are already registered.": [
    null,
    "You are already registered."
  ],
  "You are not authorized to access this service.": [
    null,
    "You are not authorized to access this service."
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "You are not permitted to create an account from this country."
  ],
  "You are not permitted to create this user account.": [
    null,
    "You are not permitted to create this user account."
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "You are on the Interior Ministry's banned player list!"
  ],
  "You can change this option at any time from your account": [
    null,
    ""
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "You can continue playing on Winamax in the meantime."
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "You can finally risk it for that big accumulator!"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "You can only upload one file at a time. Choose wisely!"
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "You can send this to us at a later time, but you must enter your information now."
  ],
  "You cannot create an account from your country.": [
    null,
    "You cannot create an account from your country."
  ],
  "You have already transferred this file.": [
    null,
    "You have already transferred this file."
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "You have entered an invalid domiciliation code"
  ],
  "You have entered an invalid phone number.": [
    null,
    "You have entered an invalid phone number."
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "You have insufficient CAPTCHA score to continue. Please try again later."
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address."
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    "You have successfully made a request to change your password. Please check your emails."
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "You must accept our Ts&Cs in order to create your account."
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    "You must choose a betting stakes limit in order to start playing."
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "You must choose a deposit limit in order to make a deposit."
  ],
  "You must choose a password.": [
    null,
    "You must choose a password."
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    "You must choose a playtime limit in order to start playing."
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    "You must choose a poker stakes limit in order to start playing."
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    "You must choose an automatic withdrawal limit in order to start playing."
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "You must choose an option for your sex in order to create your account."
  ],
  "You must enter a deposit amount.": [
    null,
    "You must enter a deposit amount."
  ],
  "You must enter an email or a phone number.": [
    null,
    "You must enter an email or a phone number."
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "You must enter the full name displayed on your bank card in order to validate your deposit."
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "You must enter your activation code in order to validate your account."
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "You must enter your bank card cryptogram in order to validate your deposit."
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "You must enter your bank card expiry date in order to validate your deposit."
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "You must enter your bank card number in order to validate your deposit."
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "You must enter your city of birth in order to create your account."
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "You must enter your city of residence in order to create your account."
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "You must enter your country of birth in order to create your account."
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "You must enter your country of residence in order to create your account."
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "You must enter your date of birth in order to create your account."
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "You must enter your department of birth in order to create your account."
  ],
  "You must enter your email in order to create your account.": [
    null,
    "You must enter your email in order to create your account."
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "You must enter your phone number in order to create your account."
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "You must enter your postal address in order to create your account."
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "You must enter your postal code in order to create your account."
  ],
  "You must enter your province to create your account.": [
    null,
    ""
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "You must not be connected to the Winamax Poker software (desktop or mobile)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "You must provide your first name in order to create your account."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "You must provide your last name in order to create your account."
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    ""
  ],
  "You need a username to play on Winamax.": [
    null,
    "You need a username to play on Winamax."
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "You need to provide us with your ID and proof of address in order to complete your registration."
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "You need to provide us with your ID in order to complete your registration."
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "You will receive an activation code by post at the following address:"
  ],
  "You're too old!": [
    null,
    "You're too old!"
  ],
  "You're too young!": [
    null,
    "You're too young!"
  ],
  "You're way too young!": [
    null,
    "You're way too young!"
  ],
  "Your ID could not be analyzed but it has been registered. Please enter your information whilst waiting for your document to be verified.": [
    null,
    "Your ID could not be analyzed but it has been registered. Please enter your information whilst waiting for your document to be verified."
  ],
  "Your ID upload has encountered an error": [
    null,
    "Your ID upload has encountered an error"
  ],
  "Your ID was registered successfully": [
    null,
    "Your ID was registered successfully"
  ],
  "Your account is frozen.": [
    null,
    "Your account is frozen."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "Your account validation is being processed. You will be notified when your documents have been validated."
  ],
  "Your address is not valid.": [
    null,
    "Your address is not valid."
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "Your automatic withdrawal limit cannot be over %1$s digits."
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    "Your automatic withdrawal limit is too big."
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    "Your automatic withdrawal limit must be greater than or equal to your deposit limit."
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    "Your automatic withdrawal limit must be more than €200."
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "Your automatic withdrawal limit must be over €0."
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "Your bank card cryptogram is not valid."
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "Your bank card expiry date is not valid."
  ],
  "Your bank card number is not valid": [
    null,
    "Your bank card number is not valid"
  ],
  "Your bet refunded in": [
    null,
    "Your bet refunded in"
  ],
  "Your betting stakes limit is too big.": [
    null,
    "Your betting stakes limit is too big."
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    "Your betting stakes limit must be more than €0."
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "Your betting stakes limit per week is not valid."
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "Your city cannot be over %1$s characters."
  ],
  "Your city is not valid.": [
    null,
    "Your city is not valid."
  ],
  "Your city is required.": [
    null,
    "Your city is required."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "Your city of birth cannot be over %1$s characters."
  ],
  "Your city of birth is not valid.": [
    null,
    "Your city of birth is not valid."
  ],
  "Your coordinates": [
    null,
    "Your details"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "Your country cannot be over %1$s characters."
  ],
  "Your country is not valid.": [
    null,
    "Your country is not valid."
  ],
  "Your country is required.": [
    null,
    "Your country is required."
  ],
  "Your country of birth is not valid.": [
    null,
    "Your country of birth is not valid."
  ],
  "Your date of birth is not valid.": [
    null,
    "Your date of birth is not valid."
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "Your date of birth must include 4 numbers."
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "Your department of birth cannot be over %1$s characters."
  ],
  "Your department of birth is not valid.": [
    null,
    "Your department of birth is not valid."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "Your deposit cannot be more than your weekly deposit limit: €%1$s."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "Your deposit limit is too big."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "Your deposit limit must be more than €0."
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "Your deposit limit per week is not valid."
  ],
  "Your deposit must be over €0.": [
    null,
    "Your deposit must be over €0."
  ],
  "Your document failed to upload": [
    null,
    "Your document failed to upload"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "Your email cannot be over %1$s characters."
  ],
  "Your email is not valid.": [
    null,
    "Your email is not valid."
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "Your file is too big. Try again with a file smaller than %1$s Mb."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    "Your first bet refunded in cash if it loses"
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "Your first name cannot be over %1$s characters."
  ],
  "Your first name is not valid.": [
    null,
    "Your first name is not valid."
  ],
  "Your identity": [
    null,
    "Your identity"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "Your identity corresponds to that of a minor."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "Your identity corresponds to that of someone who has been registered as being deceased."
  ],
  "Your information is being processed!": [
    null,
    "Your information is being processed!"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    "Your initial deposit in Freebets, up to €100*"
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "Your last name cannot be over %1$s characters."
  ],
  "Your last name is not valid.": [
    null,
    "Your last name is not valid."
  ],
  "Your limit cannot be €0": [
    null,
    "Your limit cannot be €0"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    "Your limit for %1$s must be inferior or equal to %2$s"
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    "Your limit for %1$s must be set between %2$s and %3$s"
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    "Your limit for %1$s must be superior or equal to %2$s"
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    "Your limit for %1$s must be superior or equal to your %2$s limit"
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "Your limit must be inferior or equal to %1$s"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "Your limit must be set between %1$s and %2$s"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "Your limit must be superior or equal to %1$s"
  ],
  "Your name in the rankings will be:": [
    null,
    "Your name in the rankings will be:"
  ],
  "Your number will only be used to identify you": [
    null,
    "Your number will only be used to identify you"
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "Your password cannot be over %1$s characters."
  ],
  "Your password is not valid.": [
    null,
    "Your password is not valid."
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "Your password must contain at least %1$s characters."
  ],
  "Your payment": [
    null,
    "Your payment"
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "Your phone number is mandatory in order to receive a new code."
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    "Your playtime limit must be more than 0 hours."
  ],
  "Your poker stakes limit is too big.": [
    null,
    "Your poker stakes limit is too big."
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    "Your poker stakes limit must be more than €0."
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "Your poker stakes limit per week is not valid."
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "Your postal address cannot be over %1$s characters."
  ],
  "Your postal address is required.": [
    null,
    "Your postal address is required."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "Your postal code cannot be over %1$s characters."
  ],
  "Your postal code is required.": [
    null,
    "Your postal code is required."
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "Your proof of address cannot be over one year old."
  ],
  "Your session has expired.": [
    null,
    "Your session has expired."
  ],
  "Your state is not valid.": [
    null,
    "Your state is not valid."
  ],
  "Your story begins here!": [
    null,
    "Your story begins here!"
  ],
  "Your turn to play": [
    null,
    "Your turn to play"
  ],
  "Your turn<br />to play": [
    null,
    "Your turn<br />to play"
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "Your username cannot contain over %1$s characters."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "Your username is not valid, the only authorized special characters are: .&_- and space."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "Your username must contain at least %1$s characters."
  ],
  "Your validation code is incorrect.": [
    null,
    "Your validation code is incorrect."
  ],
  "Your zip code is not valid.": [
    null,
    "Your zip code is not valid."
  ],
  "Your zip code of birth is not valid.": [
    null,
    "Your zip code of birth is not valid."
  ],
  "and": [
    null,
    ""
  ],
  "as well as our": [
    null,
    ""
  ],
  "is being processed...": [
    null,
    "is being processed..."
  ],
  "of a super-player in progress...": [
    null,
    "of a super-player in progress..."
  ],
  "of the ongoing payment...": [
    null,
    "of the ongoing payment..."
  ],
  "of your bank card processing...": [
    null,
    "of your bank card processing..."
  ],
  "or": [
    null,
    "or"
  ],
  "poker": [
    null,
    ""
  ],
  "promotions": [
    null,
    ""
  ],
  "sports betting": [
    null,
    ""
  ],
  "your document upload...": [
    null,
    "your document upload..."
  ]
}
  }
}
